
import moment from 'moment';

export const formatDate = (value, format = 'DD/MM/YYYY') => {
  return moment(value).format(format);
};

export const toNumber = (value) => {
  return Number(value);
};

export const localeNumber = (value) => {
  try {
    return toNumber(value).toLocaleString('pt-BR');
  } catch(e) {
    return null;
  }
};

export const formatCpfCnpj = (value, fallthrow = null) => {
  const formatValue = value.replace(/\D/g, '');

  if (formatValue.length === 11) return formatValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  if (formatValue.length === 14) return formatValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');

  return fallthrow ?? value;
}